import type { CmpHider } from './types';

export const borlabs: CmpHider = {
  id: 'borlabs',
  label: 'Borlabs Cookie',
  css: `
      /* Borlabs Cookie (borlabs.io, WordPress GDPR consent plugin): two
         generations ship distinct markup. The current v3 ("brlbs-cmpnt") build
         mounts its whole consent UI inside a single root container
         "#BorlabsCookieBox" appended to <body>, holding the ".brlbs-cmpnt-container"
         wrapper, a fixed full-viewport scroll/overlay layer (a div carrying the
         ".brlbs-fixed" + ".brlbs-z-max" classes, position:fixed, z-index 999999)
         that doubles as the dimming backdrop, the dialog card
         (".brlbs-cmpnt-dialog") and an explicit "#BorlabsDialogBackdrop"
         (.brlbs-cmpnt-dialog-backdrop) dimmer. Hiding "#BorlabsCookieBox" removes
         the dialog and the faded background in one go; we also list the
         container, the fixed overlay layer, and the backdrop classes defensively
         in case a build mounts them outside the box. Legacy v2 ("_brlbs") builds
         render the box in "#BorlabsCookieBox" too, plus a bottom bar "._brlbs-bar"
         and a separate fixed dimmer "#CookieBoxBackground" / "._brlbs-bg" — hide
         those as well. Borlabs locks page scroll by setting an inline
         "overflow: hidden" on <body> (and adds the "has-modal-open" class to
         <html>); the html/html-body[style*="overflow"] release rule above (added
         for Cookiebot) already out-specifies that inline lock, and we add an
         html-led "has-modal-open" class release to out-specify Borlabs's own
         "html.has-modal-open { overflow: hidden }" rule injected at runtime. */
      #BorlabsCookieBox,
      .brlbs-cmpnt-container,
      .brlbs-fixed.brlbs-z-max,
      #BorlabsDialogBackdrop,
      .brlbs-cmpnt-dialog-backdrop,
      ._brlbs-bar,
      #CookieBoxBackground,
      ._brlbs-bg { display: none !important; }
      html.has-modal-open,
      html.has-modal-open body {
        overflow: visible !important;
        position: static !important;
      }
  `,
};
